<template>
  <div id="product-external-detail">
    <b-media
      vertical-align="center"
    >
      <template #aside>
        <b-img
          rounded
          class="product-info__image"
          :src="linkStaging(data.product.images ? data.product.images[0].image_url : '', 50, 50)"
          alt=""
          @error="(event) => {
            event.target.src = require('@/assets/images/icons/broken-image.svg')
          }"
        /></template>
      <span class="font-weight-bold d-block">
        {{ data.product.name }}
        <b-badge
          v-if="data.is_purchase"
          variant="light-success"
        >
          Terbeli
        </b-badge>
        <b-badge
          v-else
          variant="light-secondary"
        >
          Belum Terbeli
        </b-badge>
      </span>
      <small class="text-muted">by {{ data.owner_gift.owner.name }}</small>
    </b-media>
    <div class="mt-1">
      <b-row
        class="mb-1"
      >
        <b-col>
          <b-badge
            v-b-tooltip.hover.top="data.product.url"
            :href="data.product.url"
            variant="light-primary"
            target="_blank"
            style="width: 100%"
            class="card-text text-truncate"
          >
            <feather-icon
              icon="LinkIcon"
              class="mr-25"
            />
            <span>{{ data.product.url }}</span>
          </b-badge>
        </b-col>
      </b-row>
    </div>
    <hr class="my-1">
    <div>
      <b-row
        v-for="(item, index) in dataList"
        :key="`list-item-data-${index}`"
        class="mb-1"
      >
        <b-col
          xl="3"
          md="4"
          sm="12"
          class="font-weight-bold"
        >
          {{ item.title }}
        </b-col>
        <b-col
          xl="9"
          md="8"
          sm="12"
        >
          {{ item.isNumber ? toCurrency(item.data) : item.data }}
        </b-col>
      </b-row>
    </div>
    <hr class="mt-1">
    <div class="mb-1">
      <small class="text-muted mb-2">Registry By</small>
      <b-card class="mt-1">
        <b-row>
          <b-col>
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  :src="linkStaging(data.owner_gift.owner.photo_url, 50, 50)"
                />
              </template>
              <span class="font-weight-boldfont-weight-bold d-block">
                {{ data.owner_gift.owner.name }}
              </span>
              <a
                :href="`https://wa.me/${data.owner_gift.owner.phone}`"
                target="_blank"
                class="link"
              >+{{ data.owner_gift.owner.phone}}</a>
            </b-media>
          </b-col>
          <b-col
            md="6"
            class="text-right"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="flat-primary"
              @click="toRegistry"
            >
              Link Registry
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BMedia,
  BRow,
  BCol,
  BBadge,
  BCard,
  BAvatar,
  BButton,
  VBTooltip,
  BImg,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BMedia,
    BRow,
    BCol,
    BBadge,
    BCard,
    BAvatar,
    BButton,
    BImg,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dataList: [
        {
          title: 'Harga',
          data: this.data.product.price,
          isNumber: true,
        },
        {
          title: 'Deskripsi',
          data: this.data.product.description,
          isNumber: false,
        },
      ],
    }
  },
  methods: {
    toRegistry() {
      window.open(`${process.env.VUE_APP_CLIENT_URL}/registry/${this.data.owner_gift.owner.username}`, '_blank')
    },
  },
}
</script>
